var _style, _g, _path, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLetter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#BCC0D8;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#243193;}\n\t.st3{fill:#E09F0D;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M157.4,135.1c-3,0-5.9-0.7-8.6-2.1l-31-16l-31,16c-2.6,1.4-5.6,2.1-8.6,2.1c-4.9,0-9.5-1.9-13-5.2 c-3.6-3.5-5.7-8.4-5.7-13.4V36.2c0-15.8,12.9-28.7,28.7-28.7l69.2,0.2c10.3,0,18.6,8.4,18.6,18.7v90.1 C176.1,126.8,167.7,135.1,157.4,135.1z M117.8,85.4c3,0,5.9,0.7,8.6,2.1l19.5,10.1V37.9l-56-0.1v59.7l19.5-10.1 C111.9,86.1,114.9,85.4,117.8,85.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M444.4,402.3H67.6c-8.3,0-15.1-6.8-15.1-15.1V53.1C52.5,23.8,76.3,0,105.6,0h300.8c29.3,0,53.1,23.8,53.1,53.1 V89c0,8.3-6.8,15.1-15.1,15.1s-15.1-6.8-15.1-15.1V53.1c0-12.6-10.3-22.9-22.9-22.9H105.6c-12.6,0-22.9,10.3-22.9,22.9v319h346.5 V165.4c0-8.3,6.8-15.1,15.1-15.1s15.1,6.8,15.1,15.1v221.9C459.5,395.6,452.7,402.3,444.4,402.3z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M67.8,496.9h376.4c25,0,45.2-20.2,45.2-45.2V220.3c0-9.9-11-15.9-19.3-10.4L266.7,343.2 c-6.5,4.3-14.9,4.3-21.4,0L41.9,209.9c-8.3-5.4-19.3,0.5-19.3,10.4v231.4C22.6,476.7,42.8,496.9,67.8,496.9z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M444.2,512H67.8c-33.2,0-60.3-27-60.3-60.3V220.3c0-15.2,12.4-27.6,27.6-27.6c5.3,0,10.6,1.6,15.1,4.5 l203.4,133.3c0.9,0.6,1.8,0.7,2.4,0.7c0.6,0,1.5-0.1,2.4-0.7l203.4-133.3c4.5-3,9.7-4.5,15.1-4.5c15.2,0,27.6,12.4,27.6,27.6v231.4 C504.5,485,477.5,512,444.2,512z M37.7,225.2v226.5c0,16.6,13.5,30.1,30.1,30.1h376.4c16.6,0,30.1-13.5,30.1-30.1V225.2L275,355.8 c-5.7,3.7-12.2,5.7-19,5.7c-6.8,0-13.3-2-19-5.7L37.7,225.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M301.3,240.9h-90.6c-8.3,0-15.1-6.8-15.1-15.1s6.8-15.1,15.1-15.1h90.6c8.3,0,15.1,6.8,15.1,15.1 S309.7,240.9,301.3,240.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M301.3,165.4h-90.6c-8.3,0-15.1-6.8-15.1-15.1s6.8-15.1,15.1-15.1h90.6c8.3,0,15.1,6.8,15.1,15.1 C316.4,158.6,309.7,165.4,301.3,165.4z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLetter);
export default __webpack_public_path__ + "static/media/letter.71e0e6c960ae9cb42c6969d432e359c2.svg";
export { ForwardRef as ReactComponent };